import { FC } from 'react';
import * as ScrollArea from '@radix-ui/react-scroll-area';
import Modal from '@new/common/ui/Modal/Modal';
import { type SubmissionDetailData } from './submissionDetail.mappers';
import { SubmissionDetailContent } from './SubmissionDetailContent';

interface SubmissionDetailModalProps {
  isOpen: boolean;
  data: SubmissionDetailData | null;
  onClose: () => void;
}

export const SubmissionDetailModal: FC<SubmissionDetailModalProps> = ({
  isOpen,
  data,
  onClose,
}) => (
  <Modal isOpen={isOpen} onClose={onClose} title={data?.title ?? ''}>
    <div className="flex h-full min-h-0 flex-col">
      <ScrollArea.Root className="flex-1 min-h-0 overflow-hidden">
        <ScrollArea.Viewport className="w-full h-full">
          {data && <SubmissionDetailContent data={data} />}
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar
          orientation="vertical"
          className="flex w-2.5 bg-transparent p-0.5 hover:bg-gray-100 transition-colors"
        >
          <ScrollArea.Thumb className="flex-1 bg-gray-300 rounded-full hover:bg-gray-400 transition-colors" />
        </ScrollArea.Scrollbar>
        <ScrollArea.Corner className="bg-gray-100" />
      </ScrollArea.Root>
    </div>
  </Modal>
);
